(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claude-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlideshow(root) {
    var slides = Array.from(root.querySelectorAll('.claude-slideshow__slide'));
    var dots = Array.from(root.querySelectorAll('.claude-slideshow__dot'));
    var prevBtn = root.querySelector('.claude-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.claude-slideshow__arrow--next');
    var pauseBtn = root.querySelector('.claude-slideshow__pause');
    var track = root.querySelector('.claude-slideshow__track');
    var current = 0;
    var total = slides.length;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var paused = false;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (total < 2) return;

    /* NOTE: slide height is content-driven (not fixed px).
       Active slide uses position: relative. Inactive slides use
       position: absolute. The track sizes to the active slide's
       content box. No height recalculation needed here. */
    function go(index) {
      var next = ((index % total) + total) % total;
      slides[current].classList.remove('claude-slideshow__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('claude-slideshow__dot--active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = next;
      slides[current].classList.add('claude-slideshow__slide--active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('claude-slideshow__dot--active');
        dots[current].setAttribute('aria-selected', 'true');
      }
      if (autoplay && !paused) {
        clearInterval(timer);
        timer = setInterval(function () { go(current + 1); }, speed);
      }
    }

    function togglePause() {
      paused = !paused;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      }
      if (track) {
        track.setAttribute('aria-live', paused ? 'polite' : 'off');
      }
      if (paused) {
        clearInterval(timer);
        timer = null;
      } else {
        timer = setInterval(function () { go(current + 1); }, speed);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', togglePause);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    if (autoplay && !reduced) {
      timer = setInterval(function () { go(current + 1); }, speed);
    }
  }

  document.querySelectorAll('[data-claude-slideshow]').forEach(function (el) {
    if (!el._csInit) {
      el._csInit = true;
      initSlideshow(el);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
